export default {
  SET_ALEX_DATA(state, value) {
    state.data = value;
  },
  SET_CHAT_ID(state, value) {
    state.chatId = value
  },
  TOGGLE_ALEX_CHAT_MODAL(state, value) {
    state.alexChatModal = value
  },
  SET_TRAINING_LIBRARY_EMOTIONHACK_DATA(state, value) {
    // state.trainingItemList.push(...value);
    state.trainingItemList = value;
  },
  SET_TEST_LIBRARY_GALA_DATA(state, value) {
    // state.trainingItemList.push(...value);
    state.testItemList = value;
  },
  SET_USER_SEGMENTS(state, value) {
    state.userSegments = value;
  },
  SET_ALEX_USER_DATA(state, value){
    state.alexUserData = value;
  },
  SET_ALEX_Department_USER_DATA(state, value){
    state.alexDepartmentUserData = value;
  }
}
